<div class="d-flex flex-column gap-4 h-100 overflow-auto">
  <!-- Table Container -->
  <div class="flex-grow-1 overflow-auto h-100" data-tour-id="tour-track-table">
    @if (selectedTrack(); as track) {
      <div class="d-flex flex-column gap-5 overflow-auto h-100">
        <div class="d-flex justify-content-between align-items-center mh-70p">
          <si-form-item class="w-50" label="Parameter">
            <select
              aria-label="number"
              class="form-select w-100"
              data-tour-id="tour-track-parameter-select"
              [disabled]="this.editableRowIndex() !== null || this.hasInvalidRows()"
              [(ngModel)]="selectedParameterName"
            >
              @for (parameter of parameterNames(); track $index) {
                <option [value]="parameter">
                  {{ `TRACK.PARAMETERS.${parameter}` | translate }}
                </option>
              }
            </select>
          </si-form-item>
          <div class="d-flex align-items-center gap-3">
            @if (track.trackDataQuery) {
              <app-track-map
                #trackMap
                [track]="track"
                (editRequested)="editRouteRequested.emit($event)"
              />
              <button
                #viewRouteBtn
                type="button"
                class="btn btn-circle btn-lg btn-ghost element-location"
                aria-label="view route map"
                placement="top"
                [siTooltip]="'TRACK.VIEW_ON_MAP_TOOLTIP' | translate"
                [disabled]="buttonsDisabled()"
                (click)="trackMap.openModal(); viewRouteBtn.blur()"
              ></button>
            }
            <button
              type="button"
              class="btn btn-circle btn-lg btn-ghost element-trend"
              aria-label="open in schedule"
              siTooltip="Plot"
              placement="top"
              data-tour-id="tour-track-plot-button"
              [disabled]="
                buttonsDisabled() ||
                selectedParameterName() === 'station_data' ||
                selectedParameterName() === 'gps_data' ||
                (selectedDataSet()?.length ?? 0) === 0
              "
              (click)="openModal(trackPlotModalTemplate)"
            ></button>
            <button
              type="button"
              class="btn btn-circle btn-lg btn-ghost element-right-2"
              placement="top"
              aria-label="open in schedule"
              [siTooltip]="'TRACK.INSERT_INTO_SCHEDULE_TOOLTIP' | translate"
              [disabled]="buttonsDisabled()"
              (click)="openInScheduleClicked()"
            ></button>
            <button
              type="button"
              class="btn btn-circle btn-lg btn-ghost element-repeat"
              aria-label="reverse"
              placement="top"
              [siTooltip]="'SHARED.REVERSE' | translate"
              [disabled]="buttonsDisabled()"
              (click)="reverseTrackParameters()"
            ></button>
          </div>
        </div>
        @if (selectedDataSet(); as dataSet) {
          @if (dataSet.length === 0) {
            <div class="d-flex justify-content-center align-items-center h-100">
              <si-empty-state
                empty-content
                icon="element-technical-operator"
                [heading]="'SHARED.INFO_NO_DATA_AVAILABLE' | translate"
              />
            </div>
          } @else {
            <div class="table-responsive overflow-auto h-100">
              <table class="table table-hover table-sm overflow-auto">
                <thead>
                  <tr>
                    @for (key of trackParameterKeys(); track $index) {
                      <th scope="col">
                        {{ `TRACK.COLUMN_NAMES.${getDisplayNameForKeyName(key)}` | translate }}
                      </th>
                    }
                    <th scope="col"></th>
                    <th scope="col"></th>
                  </tr>
                </thead>
                <tbody class="overflow-auto">
                  @if (selectedTrack(); as selectedTrackData) {
                    @for (
                      row of selectedTrackData.parameters[selectedParameterName()];
                      track $index;
                      let i = $index
                    ) {
                      <tr class="table-row">
                        @for (key of trackParameterKeys(); track $index) {
                          <td (dblclick)="editableRowIndex() === null ? setEditableRow(i) : null">
                            @if (editableRowIndex() === i) {
                              <form (ngSubmit)="saveRow(i)">
                                <input
                                  required="true"
                                  class="form-control"
                                  name="inputField"
                                  [type]="
                                    key === 'trackParameter1' &&
                                    selectedParameterName() === 'station_data'
                                      ? 'text'
                                      : 'number'
                                  "
                                  [(ngModel)]="row[key]"
                                />
                              </form>
                            } @else {
                              <span>{{ row[key] }}</span>
                            }
                            @if (rowValidationStatus()[i] !== null && key === 'position') {
                              <div class="text-danger">
                                {{ rowValidationStatus()[i] }}
                              </div>
                            }
                          </td>
                        }
                        <td>
                          <div class="d-flex align-items-center gap-3">
                            @if (editableRowIndex() === i) {
                              <button
                                type="button"
                                role="button"
                                class="btn btn-ghost btn-circle element-ok btn-lg"
                                aria-label="Edit entry"
                                siDropdownToggle
                                (click)="saveRow(i)"
                              ></button>
                            } @else {
                              <button
                                type="button"
                                role="button"
                                class="btn btn-ghost btn-circle element-edit action-buttons btn-lg"
                                aria-label="Edit entry"
                                siDropdownToggle
                                (click)="setEditableRow(i)"
                              ></button>
                            }
                            <button
                              type="button"
                              role="button"
                              class="btn btn-ghost btn-circle element-delete action-buttons btn-lg"
                              aria-label="Remove entry"
                              siDropdownToggle
                              (click)="removeEntry(i)"
                            ></button>
                            <app-track-comment
                              [selectedParameterName]="selectedParameterName()"
                              [entryIndex]="i"
                              [changesSummaryMap]="changesSummaryMap()"
                              [isMandatoryForWarning]="
                                pendingWarningToggleIndex() === i && forceCommentModalForWarning()
                              "
                              [warningToggleContext]="
                                warningToggleContext()?.entryIndex === i
                                  ? warningToggleContext()
                                  : null
                              "
                              [attr.data-comment-index]="i"
                              [(selectedTrack)]="selectedTrack"
                              (commentAdded)="onCommentAdded()"
                              (warningCommentCanceled)="onWarningCommentCanceled()"
                            />
                          </div>
                        </td>
                        <td>
                          <button
                            type="button"
                            role="button"
                            class="btn btn-lg btn-circle"
                            aria-label="Remove entry"
                            siDropdownToggle
                            [ngClass]="{
                              'btn-ghost element-validation-warning action-buttons':
                                !row['warning'],
                              'btn-tertiary-warning element-warning': row['warning']
                            }"
                            (click)="toggleRowWarningStateClicked(i)"
                          ></button>
                        </td>
                      </tr>
                    }
                  }
                </tbody>
              </table>
            </div>
          }
        }
      </div>
    }
  </div>

  <!-- Add new Entry -->
  <table class="table table-sm p-0 m-0">
    <thead class="h-0">
      <tr>
        @for (key of trackParameterKeys(); track $index) {
          <th scope="col"></th>
        }
        <th scope="col"></th>
      </tr>
    </thead>
    <tbody>
      <tr [formGroup]="newRowDataForm">
        @for (key of trackParameterKeys(); track $index) {
          <td>
            <input
              class="form-control w-100"
              [type]="
                selectedParameterName() === 'station_data' && key === 'trackParameter1'
                  ? 'text'
                  : 'number'
              "
              [formControlName]="key"
              [name]="key"
              [placeholder]="`TRACK.COLUMN_NAMES.${getDisplayNameForKeyName(key)}` | translate"
            />
            @if (key === 'position' && newRowInfoMessage !== null) {
              <div class="text-danger">
                {{ newRowInfoMessage }}
              </div>
            }
          </td>
        }
        <td>
          <button
            type="submit"
            class="btn btn-secondary w-100"
            [disabled]="newRowDataForm.invalid || editableRowIndex()"
            (click)="addNewRow()"
          >
            {{ 'TRACK.ADD_NEW_ROW' | translate }}
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Modal Templates -->
<ng-template #trackPlotModalTemplate let-modalRef="modalRef">
  <div class="modal-header">
    <h4 class="modal-title d-flex align-items-center gap-2" id="sample-modal-title"
      >{{ `TRACK.PARAMETERS.${selectedParameterName()}` | translate }} Plot
      <button
        type="button"
        class="btn btn-circle btn-ghost btn-sm element-help"
        aria-label="Plot info"
        [siTooltip]="`TRACK.PLOT_INFO.${selectedParameterName()}` | translate"
      ></button>
    </h4>
    <div class="d-flex align-items-center gap-3 ms-auto">
      <div class="d-flex align-items-center gap-2 mb-0">
        <span class="mb-0">Edit Mode</span>
        <div class="form-check form-switch mb-0 d-flex align-items-center">
          @if (trackPlotRef(); as plotRef) {
            <input
              type="checkbox"
              class="form-check-input mt-0"
              [formControl]="plotRef.editModeControl"
            />
          } @else {
            <input type="checkbox" class="form-check-input mt-0" disabled />
          }
        </div>
      </div>
      <si-content-action-bar
        toggleItemLabel="toggle"
        viewType="expanded"
        [primaryActions]="plotModalPrimaryActions"
      />
    </div>
    <button
      type="button"
      class="btn btn-circle btn-ghost element-cancel"
      aria-label="Close modal"
      (click)="closeModal(modalRef)"
    ></button>
  </div>
  <div class="modal-body">
    @if (selectedTrack(); as track) {
      <app-track-plot
        #trackPlotRef
        [track]="track"
        [dataKey]="this.selectedParameterName()"
        (dataPointChanged)="onDataPointChanged($event)"
        (dataPointAdded)="onDataPointAdded($event)"
        (dataPointDeleted)="onDataPointDeleted($event)"
        (commentAdded)="onCommentAddedFromPlot($event)"
      />
    }
  </div>
</ng-template>
